export default __webpack_public_path__ + "static/media/farmacia-inactivo.d4515db9.svg";